import { ActivityType } from '../value-objects/ActivityType';

/**
 * Activity Entity
 * Represents a recent activity in the dashboard
 */
export interface ActivityProps {
  id: string;
  title: string;
  time: string;
  type: ActivityType;
  actorId?: string;
  actorName?: string;
  entityType?: string;
  entityId?: number;
  metadata?: Record<string, unknown>;
  createdAt?: Date;
}

export class Activity {
  private readonly props: ActivityProps;

  private constructor(props: ActivityProps) {
    this.props = props;
  }

  static create(props: ActivityProps): Activity {
    return new Activity(props);
  }

  get id(): string {
    return this.props.id;
  }

  get title(): string {
    return this.props.title;
  }

  get time(): string {
    return this.props.time;
  }

  get type(): ActivityType {
    return this.props.type;
  }

  get actorId(): string | undefined {
    return this.props.actorId;
  }

  get actorName(): string | undefined {
    return this.props.actorName;
  }

  get entityType(): string | undefined {
    return this.props.entityType;
  }

  get entityId(): number | undefined {
    return this.props.entityId;
  }

  get metadata(): Record<string, unknown> | undefined {
    return this.props.metadata;
  }

  get createdAt(): Date | undefined {
    return this.props.createdAt;
  }

  toPlainObject(): ActivityProps {
    return { ...this.props };
  }
}
